import React from "react";

import PartnerAddEmployeeModal from "EmployerApplication/Components/PartnerAddEmployeeModal";
import PartnerEditEmployeeModal from "EmployerApplication/Components/PartnerEditEmployeeModal";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { compareByEmail } from "Utils/comparisons";

import { MenuDropdown, Option } from "Cobalt/Dropdown";
import { StandaloneTrigger } from "Cobalt/Modal";
import { Table, HeaderTR, TH, TR, TD, EllipsisTD, SnugTD } from "Cobalt/TableV2";
import Icon from "Common/Icon";
import Button from "Theme/Button";

import type { AddEmployeeRow } from "EmployerApplication/createStore";

import makeBem from "Utils/makeBem";

const bem = makeBem("EmployeeTable");

type Props = {
  onDeleteEmployee: (arg0: string) => void;
  employees: Array<AddEmployeeRow>;
  include1099: boolean;
  includeOwner: boolean;
};

type State = {
  disableRemove: Record<string, boolean>;
};

export class PartnerEmployeeTableDumb extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      disableRemove: {},
    };
  }

  handleClickDeleteEmployee(hashId: string) {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "add_employee",
      label: "remove",
    });

    this.props.onDeleteEmployee(hashId);
    const disableRemove = { ...this.state.disableRemove, [hashId]: true };
    this.setState({ disableRemove });
  }

  render() {
    const { employees, include1099, includeOwner } = this.props;

    return (
      <>
        {employees.length > 0 && (
          <Table>
            <thead>
              <HeaderTR>
                <TH width="200px">Name</TH>
                <TH>Email</TH>
                <TH />
              </HeaderTR>
            </thead>
            <tbody>
              {employees.sort(compareByEmail).map(
                (employee) =>
                  employee.is_eligible && (
                    <TR key={employee.hash_id}>
                      <EllipsisTD min-width="150px">{employee.full_name}</EllipsisTD>
                      <TD>{employee.email ? employee.email : "--"}</TD>
                      <SnugTD>
                        <MenuDropdown pullRight>
                          <StandaloneTrigger
                            employee={employee}
                            trigger={(props) => (
                              <Option
                                onClick={(e) => {
                                  props.onClick(e);
                                }}
                              >
                                <Icon icon="pencil-alt" flavor="solid" mr={3} />
                                Edit
                              </Option>
                            )}
                            modal={(props) => (
                              <PartnerEditEmployeeModal
                                form={`editEmployeeForm_${employee.hash_id}`}
                                include1099={include1099}
                                includeOwner={includeOwner}
                                {...props}
                              />
                            )}
                          />

                          <Option className={bem(null, "red")} onClick={() => this.handleClickDeleteEmployee(employee.hash_id)}>
                            {this.state.disableRemove[employee.hash_id] == true ? (
                              <>
                                <Icon icon="cog" mr={3} spin flavor="solid" />
                                Loading...
                              </>
                            ) : (
                              <>
                                <Icon icon="trash" mr={3} />
                                Remove
                              </>
                            )}
                          </Option>
                        </MenuDropdown>
                      </SnugTD>
                    </TR>
                  ),
              )}
            </tbody>
          </Table>
        )}

        <StandaloneTrigger
          trigger={(props) => (
            <Button
              color="gray"
              mt={4}
              disabled={props.disabled}
              onClick={(e) => {
                props.onClick(e);
                AnalyticsTracking.trackEvent("add_employees_add_owner_or_contractor", {});
              }}
            >
              Add Person
            </Button>
          )}
          modal={(props) => <PartnerAddEmployeeModal include1099={include1099} includeOwner={includeOwner} {...props} />}
        />
      </>
    );
  }
}

export default PartnerEmployeeTableDumb;
